// From the pure schema entry of platform: this file is bundled into the web app through ./schema.
import { definePermissions } from '@mkcore/platform/schema';

/**
 * Permissions of approvals (D14). approve is the gate for everything that goes outside or touches money; the seed
 * roles give it to owner and admin only, and an agent identity never gets it (docs/01-architectuur/10-beveiliging.md).
 */
export const approvalPermissions = definePermissions('approvals', {
  read: 'View approval requests and their decisions',
  approve: 'Decide an approval request: approve, reject or ask for a revision',
});
